import React, {useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import appleIcon from './../imgs/Apple.svg';
import {Form, Checkbox, message, Spin} from 'antd';
import googleIcon from './../imgs/google.svg';
import {fetchToken} from '../utils/helpers/user';
import {setTokens} from '../redux/actions/auth';
import {useDispatch, useSelector} from 'react-redux';
import {gql, useLazyQuery} from '@apollo/client';
import {SEARCH_PROFILE} from '../graphql/query/profiles';
import {isEmpty} from 'lodash';
import {setStrapiResData} from '../redux/actions/strapiRes';
import {STRAPI_DEVELOPMENT, STRAPI_PRODUCTION} from '../constants/Api';

function onChange(e) {
  console.log(`checked = ${e.target.checked}`);
}

const Login = () => {
  const [email, setEmail] = useState('');
  const [isUserValid, setUserValid] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [password, setPassword] = useState('');
  const [loader, setLoader] = useState(false);
  const [token, setToken] = useState(null);
  const history = useHistory();
  const strapiRes = useSelector((state) => state.strapiRes);

  const dispatch = useDispatch();

  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const [getProfileByEmail] = useLazyQuery(gql(SEARCH_PROFILE), {
    onCompleted: (data) => queryCallBackHandler(data),
    onError: (error) => console.warn(error),
  });

  const emailonChange = (event) => {
    const validate = emailRegex.test(
      String(event.target.value).toLocaleLowerCase(),
    );
    if (validate) {
      setEmail(event.target.value);
      setUserValid(true);
    } else {
      setUserValid(false);
      setEmail(event.target.value);
    }
  };

  const handleChangePassword = (event) => {
    if (password.trim().length >= 7) {
      setPassword(event.target.value);
      setIsPasswordValid(true);
    } else {
      setPassword(event.target.value);
      setIsPasswordValid(false);
    }
  };

  const handleValidUser = (event) => {
    const validate = emailRegex.test(
      String(event.target.value).toLocaleLowerCase(),
    );

    if (validate) {
      setUserValid(true);
    } else {
      setUserValid(false);
    }
  };

  const queryCallBackHandler = ({searchProfileByEmail}) => {
    if (isEmpty(searchProfileByEmail)) {
      return profileNotAvailable();
    }

    profileAvailable(searchProfileByEmail);
  };

  const profileNotAvailable = () => {
    localStorage.setItem('accessToken', token);
    localStorage.setItem('accountType', 'custom');

    dispatch(
      setTokens({
        authToken: token,
        accessToken: token,
      }),
    );

    setLoader(false);
    history.push('/userdetails');
  };

  const profileAvailable = async (searchProfileByEmail) => {
    dispatch(
      setTokens({
        authToken: token,
        accessToken: null,
      }),
    );
    dispatch({
      type: 'SET_STRAPI_RES_DATA',
      payload: searchProfileByEmail[0],
    });
    await localStorage.setItem('profileId', searchProfileByEmail[0]?.id);
    await localStorage.setItem('email', searchProfileByEmail[0]?.email)
    setLoader(false);
    history.push(`/${strapiRes.userName}`);
  };

  const customSignInHandler = async () => {
    setLoader(true);

    const {jwt, user, error, message} = await fetchToken(email, password);

    if (error) {
      setLoader(false);
      const {
        messages: [{message: errorMessage, id}],
      } = message[0];

      if (id === 'Auth.form.error.blocked') return displayError(errorMessage);

      if (id === 'Auth.form.error.confirmed') return displayError(errorMessage);

      if (id === 'Auth.form.error.invalid')
        return displayError('Incorrect email or password!');
    }

    await localStorage.setItem('authToken', jwt);
    await localStorage.setItem('userId', user?.id.toString());
    await localStorage.setItem('email', user?.email);

    setToken(jwt);

    getProfileByEmail({
      variables: {
        email: user?.email,
      },
    });

    dispatch(
      setTokens({
        authToken: jwt,
        accessToken: null,
      }),
    );

    // setLoader(false);
  };

  const displayError = (errorMessage) => {
    setLoader(false);
    message.error(errorMessage);
  };

  const socialAuth = (provider) => {
    window.location = `${
      process.env.NODE_ENV === 'production'
        ? STRAPI_PRODUCTION
        : STRAPI_DEVELOPMENT
    }/connect/${provider}`;
  };

  return (
    <div className="signup-container">
      <h1 className="headingz">ZOMBIE</h1>
      <Spin
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        }}
        spinning={loader}>
        <div className="card-body">
          <div className="row d-flex sign">
            <h1 className="heading">Sign in</h1>
            <p className="text-center already mt-2">
              Already have an account?{' '}
              <span className="Sign-text">
                <Link to="/signup">Sign up</Link>{' '}
              </span>
            </p>
          </div>
          <div className="row justify-content-center signup-with">
            {/* <div className="col-6"> */}
              {/* <button className="apple">
                <img src={appleIcon} alt="" />
                Continue with Apple
              </button> */}
            {/* </div> */}
            <div className="col-6">
              <button className="google" onClick={() => socialAuth('google')}>
                <img src={googleIcon} alt="" />
                Continue with Google
              </button>
            </div>
          </div>
          <div className="row d-flex line-box">
            <div className="col-5 p-0">
              <span className="line"></span>
            </div>
            <div className="col-1 mr-2">
              <p>or</p>
            </div>
            <div className="col-5 p-0">
              <span className="lines"></span>
            </div>
          </div>
          <div className="content-wrapper">
            <Form className="form" onFinish={customSignInHandler}>
              <div className="input-field">
                <label>Email</label>
                {email && !isUserValid ? (
                  <p className="error">Invalid User</p>
                ) : null}
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(event) => emailonChange(event)}
                  onEndEditing={(event) =>
                    handleValidUser(event.nativeEvent.text)
                  }
                />
              </div>
              <div className="input-field">
                <label>Password</label>
                {password && !isPasswordValid ? (
                  <p className="error">Atleast 8 characters</p>
                ) : null}
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(event) => handleChangePassword(event)}
                />
              </div>
              <Checkbox onChange={onChange}>Remember me</Checkbox>
              <div className="signUp pb-4 pt-3">
                <button className="google" onClick={customSignInHandler}>
                  Sign in
                </button>
              </div>
            </Form>
          </div>
          <div className="pt-4 d-flex">
            <p className="bottom-text">
              By signing up, you agree to our{' '}
              <span className="bottom-bold">Terms and Conditions </span> and{' '}
              <span className="bottom-bold"> Privacy Statement </span>
            </p>
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default Login;
